export default __webpack_public_path__ + "static/media/Zoom-Out.760c3fe8.svg";